export default class PanelPost {
  constructor(options) {
    this.opts = options;
    this.selector = '.' + this.opts.mainClass;
    this.render();
    this.initialize();
  }

  render() {
    let panelpostsContainer = document.querySelector(this.opts.containerSelector);
    this.post = this.createEl(`
    <div class="${this.opts.mainClass} post ${this.opts.additionalClasses}">
    <div class="post-background"></div>
    <div class="post-content">
        <a class="post-image">
            <div class="post-badge"><div class="badge"></div></div>
            <img src="" class="img-fluid">
        </a>
        <div class="post-body">
            <div class="post-body-type-holder">
            <div class="post-body-type"><span></span></div>
            </div>
            <div class="post-body-title">
                <a href="" class="title title-s"></a>
            </div>
            <div class="post-body-excerpt"></div>
            <div class="post-body-button">
                <a href="#" class="btn btn-readmore btn-white btn-size-full"></a>
            </div>
            <div class="post-body-legalinfo legalinfo"></div>
        </div>
      </div>
    </div>`);
    panelpostsContainer.appendChild(this.post);
  }
  initialize() {
    if (this.opts.imgSrc) {
      this.post.querySelector('.post-image img').src = this.opts.imgSrc;
      this.post.querySelector('.post-background').style.backgroundImage = 'url(' + this.opts.imgSrc + ')';
    }
    if (this.opts.backgroundSrc) {
      this.post.querySelector('.post-image').style.backgroundImage = 'url(' + this.opts.backgroundSrc + ')';
      this.post.querySelector('.post-background').style.backgroundImage = 'url(' + this.opts.backgroundSrc + ')';
    }
    if (this.opts.badge) {
      this.post.querySelector('.post-badge .badge').innerHTML = this.opts.badge;
    }
    if (!this.opts.badge) {
      this.post.querySelector('.post-badge .badge').style.visibility = 'hidden';
    }
    if (this.opts.label) {
      this.post.querySelector('.post-body-type span').innerHTML = this.opts.label;
    }
    if (!this.opts.label) {
      this.post.querySelector('.post-body-type-holder').style.visibility = 'hidden';
    }
    if (this.opts.title) {
      this.post.querySelector('.post-body-title .title').innerHTML = this.opts.title;
    }
    if (this.opts.description) {
      this.post.querySelector('.post-body-excerpt').innerHTML = this.decodeHTML(this.opts.description);
    }
    if (this.opts.btnText) {
      this.post.querySelector('.post-body-button .btn').innerHTML = this.opts.btnText;
    }
    if (this.opts.legalinfo) {
      this.post.querySelector('.post-body-legalinfo').innerHTML = this.decodeHTML(this.opts.legalinfo);
    }
    if (this.opts.isTournament) {
      this.post.querySelector('.post-image').innerHTML =
        '<div class="counter text-center"><div class="counter-thumb"></div><div class="clock"><svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.875 0.0957031C2.55859 0.0957031 2.3125 0.359375 2.3125 0.658203C2.3125 0.974609 2.55859 1.2207 2.875 1.2207H3.15625V1.83594C1.39844 2.09961 0.0625 3.61133 0.0625 5.43945C0.0625 7.46094 1.69727 9.0957 3.71875 9.0957C5.72266 9.0957 7.375 7.46094 7.375 5.43945C7.375 4.71875 7.14648 4.0332 6.77734 3.45312L7.19922 3.03125C7.42773 2.82031 7.42773 2.45117 7.19922 2.24023C6.98828 2.01172 6.61914 2.01172 6.4082 2.24023L6.02148 2.60938C5.5293 2.20508 4.93164 1.94141 4.28125 1.83594V1.2207H4.5625C4.86133 1.2207 5.125 0.974609 5.125 0.658203C5.125 0.359375 4.86133 0.0957031 4.5625 0.0957031H3.71875H2.875ZM4.14062 3.4707V5.7207C4.14062 5.9668 3.94727 6.14258 3.71875 6.14258C3.47266 6.14258 3.29688 5.9668 3.29688 5.7207V3.4707C3.29688 3.24219 3.47266 3.04883 3.71875 3.04883C3.94727 3.04883 4.14062 3.24219 4.14062 3.4707Z" fill="#070808"/></svg><span class="days">0d</span><span class="hours">0</span><span class="spacer">h</span><span class="minutes">0</span><span class="spacer">m</span><span class="seconds">0</span>s</div><span></span></div>';
      if (this.opts.icon) {
        this.post.querySelector('.counter-thumb').style.backgroundImage = 'url(' + this.opts.icon + ')';
      }
      if (this.opts.prizePool) {
        this.post.querySelector('.counter > span').innerHTML = this.opts.prizePool;
      }
    }
    if (this.opts.link) {
      let linksList = this.post.querySelectorAll('a');
      for (let i = 0, len = linksList.length; i < len; i++) {
        linksList[i].setAttribute('href', this.opts.link);
      }
    }
  }
  createEl(domstring) {
    const html = new DOMParser().parseFromString(domstring, 'text/html');
    return html.body.firstChild;
  }
  decodeHTML(html) {
    let temp = document.createElement('textarea');
    temp.innerHTML = html;
    return temp.value.replace(/<[^>]*>?/gm, '');
  }
  setAttribute(attrName, attrValue) {
    this.post.setAttribute(attrName, attrValue);
  }
  getElement() {
    return this.post;
  }
}
